export default __webpack_public_path__ + "static/2010-2-37168c2991a86895b532a483b240219a.jpg";